import { csx } from '@vtex/admin-ui'

const styles = {
  grid: csx({
    rowGap: '$space-3',
    columnGap: '$space-4',
  }),
  removeButton: csx({
    marginTop: '$space-6',
  }),
  counter: csx({
    marginLeft: 'auto',
  }),
}

export default styles
